import React, {useState} from "react";
import { Input, Form, DatePicker, Divider, Col, Radio, Upload, message, Select, Row, Checkbox } from "antd";
import InboxOutlined from "@ant-design/icons/lib/icons/InboxOutlined";
import moment from "moment";
import dayjs from "dayjs";

function Page2({ formData, setFormData, form, onboardingFields }) {
    const { Dragger } = Upload;
    const {Option} = Select;
    const [showMasters, setShowMasters] = useState(
        formData.degree_2 || 
        formData.institute_2 || 
        formData.university_2 || 
        formData.area_of_study_2 || 
        formData.start_year_2 || 
        formData.end_year_2
    );
    const [isOtherSelected, setIsOtherSelected] = useState(false);
    const [fileList, setFileList] = useState(formData.state_id?formData.state_id.fileList:[]);

    const handleMastersCheckbox = (e) => {
        setShowMasters(e.target.checked);
        if (!e.target.checked) {
            form.setFieldsValue({
                degree_2: undefined,
                institute_2: undefined,
                university_2: undefined,
                area_of_study_2: undefined,
                start_year_2: undefined,
                end_year_2: undefined
            });
        }
    };

    const handleRadioChange = (e) => {
      console.log(e.target.value )
        if (e.target.value === 'Other') {
            setIsOtherSelected(true);
        } else {
            setIsOtherSelected(false);
        }
        if (formData && (formData.gc_copy || formData.gc_ead_copy || formData.opt_copy || formData.h4_ead_copy || formData.cpt_copy || formData.other_copy)) {
          const { gc_ead_copy, opt_copy, h4_ead_copy, cpt_copy, other_copy ,gc_copy } = formData;
          if (gc_copy) delete formData.gc_copy;
          if (gc_ead_copy) delete formData.gc_ead_copy;
          if (opt_copy) delete formData.opt_copy;
          if (h4_ead_copy) delete formData.h4_ead_copy;
          if (cpt_copy) delete formData.cpt_copy;
          if (other_copy) delete formData.other_copy;
          setFormData({ ...formData });
          form.resetFields([ 'gc_copy' ,'gc_ead_copy', 'opt_copy', 'h4_ead_copy', 'cpt_copy', 'other_copy' ]);
          localStorage.setItem('formData', JSON.stringify({ ...formData }));
        }
    };

    const handleBeforeUpload = (file) => {
        return false;
    };
    
    const acceptableFileTypes = ['jpg', 'jpeg', 'png', 'gif', 'pdf'];
    const getAcceptedFileTypesText = () => {
        return acceptableFileTypes.join(', ').toUpperCase();
    };

    const filterFilesByType = (fileList) => {
      return fileList.map(file => {
          const fileExtension = file.name.split('.').pop().toLowerCase();
          const isAcceptableFileType = acceptableFileTypes.includes(fileExtension);
  
          if (!isAcceptableFileType) {
              message.error(`Unsupported file type: ${file.name}`);
              return null;
          }
  
          return file;
      }).filter(Boolean); 
  };
  

    const handleFileChange = (info) => {
        let updatedFileList = [...info.fileList];

        updatedFileList = updatedFileList.filter((file) => {
            if (file.status === 'error') {
                message.error(`${file.name} file upload failed.`);
            }
            return file.status !== 'error';
        });
        updatedFileList = filterFilesByType(updatedFileList);
        setFileList(updatedFileList);
        form.validateFields(['state_id']).catch(() => {});
    };
    // 
    const [fileListDLFront, setFileListDLFront] = useState(formData.driving_license_front?formData.driving_license_front.fileList:[]);
    // const [fileListDLBack, setFileListDLBack] = useState(formData.driving_license_back?formData.driving_license_back.fileList:[]);

    const handleFileChangeDLFront = (info) => {
        let updatedFileList = [...info.fileList];
        updatedFileList = updatedFileList.filter((file) => {
            if (file.status === 'error') {
                message.error(`${file.name} file upload failed.`);
            }
            return file.status !== 'error';
        });
        updatedFileList = filterFilesByType(updatedFileList);
        setFileListDLFront(updatedFileList);
    };

    // const handleFileChangeDLBack = (info) => {
    //     let updatedFileList = [...info.fileList];
    //     updatedFileList = updatedFileList.filter((file) => {
    //         if (file.status === 'error') {
    //             message.error(`${file.name} file upload failed.`);
    //         }
    //         return file.status !== 'error';
    //     });
    //     setFileListDLBack(updatedFileList);
    // };

    const uploadProps = {
        multiple: false,
        fileList,
        beforeUpload: handleBeforeUpload,
        onChange: handleFileChange,
    };
  return (
    <div>
        <Form
          // layout="inline"
          form={form}
          initialValues={formData}
          onValuesChange={(changedValues, allValues) => {
            setFormData({ ...formData, ...allValues })
            }}
          className="gx-modal-box-form-item"
        >
          <Row>
            {onboardingFields && onboardingFields.includes('education_details') && (
                <>
            <Divider/>
            <div style={{width:"100%",textAlign:"center",fontWeight:"bold",fontSize:"15px"}}>Education Details</div>
            <Divider/>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Input.Group>
                <Form.Item label="Bachelor's Degree"
                           rules={[{
                             required: true,
                             message: 'Please enter degree name!'
                           }]}
                           name={'degree_1'}>
                  <Input type="text" autoComplete="off"/>
                </Form.Item>
              </Input.Group>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Input.Group>
                <Form.Item label="Institute"
                           name={'institute_1'} 
                          //  rules={[{
                          //   required: true,
                          //   message: 'Please enter insitute name!'
                          // }]}
                          >
                  <Input type="text" autoComplete="off"/>
                </Form.Item>
              </Input.Group>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Input.Group>
                <Form.Item label="University"
                           name={'university_1'}
                           rules={[{
                            required: true,
                            message: 'Please enter university name!'
                          }]}>
                  <Input type="text" autoComplete="off"/>
                </Form.Item>
              </Input.Group>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Input.Group>
                <Form.Item label="Area of Study"
                           name={'area_of_study_1'}
                          //  rules={[{
                          //   required: true,
                          //   message: 'Please enter Area of Study!'
                          // }]}
                          >
                  <Input type="text" autoComplete="off"/>
                </Form.Item>
              </Input.Group>
            </Col> 
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label="Started On"
                name={'start_year_1'}
                rules={[
                  {
                    required: true,
                    message: 'Please enter start year!'
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (value && dayjs(value).isAfter(dayjs())) {
                        return Promise.reject(new Error("Date cannot be in the future."));
                      }
                      if (!value || !getFieldValue("end_year_1") || dayjs(value).isBefore(getFieldValue("end_year_1"))) {
                        return Promise.resolve();
                      }

                      return Promise.reject(new Error('Start date must be before end date!'));
                    },
                  }),
                ]}

              >
                <DatePicker
                  format="MM/DD/YYYY"
                  autoComplete="off"
                  className="ant-input"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label="Ended On"
                name={'end_year_1'}
                rules={[{
                  required: true,
                  message: 'Please enter end year!'
                },  ({ getFieldValue }) => ({
                  validator(_, value) {

                    if (value && dayjs(value).isAfter(dayjs())) {
                      return Promise.reject(new Error("Date cannot be in the future."));
                    }
                    if (!value || !getFieldValue("start_year_1") || dayjs(value).isAfter(getFieldValue("start_year_1"))) {
                      return Promise.resolve();
                    }

                    return Promise.reject(new Error('End date must be after start date!'));
                  },
                }),]}
              >
                <DatePicker
                  format="MM/DD/YYYY"
                  autoComplete="off"
                  className="ant-input"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
                    <Divider/>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item>
              <Checkbox 
                checked={showMasters}
                onChange={handleMastersCheckbox}
              >
                Add Master's Education
              </Checkbox>
              </Form.Item>
            </Col>
        {showMasters && (
                        <>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Input.Group>
                <Form.Item 
                label="Master's Degree"
                name={'degree_2'}
                rules={[
                  {
                    required: true,
                    message: "Please enter Master's Degree!"
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (showMasters && !value) {
                        return Promise.reject();
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
                >
                  <Input type="text" autoComplete="off"/>
                </Form.Item>
              </Input.Group>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Input.Group>
                <Form.Item label="Institute"
                           name={'institute_2'} 
                          >
                  <Input type="text" autoComplete="off"/>
                </Form.Item>
              </Input.Group>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Input.Group>
                <Form.Item label="University"
                           name={'university_2'}
                           rules={[
                            {
                              required: true,
                              message: "Please enter university name!"
                            },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (showMasters && !value) {
                                  return Promise.reject();
                                }
                                return Promise.resolve();
                              },
                            }),
                          ]}
                          >
                  <Input type="text" autoComplete="off"/>
                </Form.Item>
              </Input.Group>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Input.Group>
                <Form.Item label="Area of Study"
                           name={'area_of_study_2'}
                           
                          >
                  <Input type="text" autoComplete="off"/>
                </Form.Item>
              </Input.Group>
            </Col> 
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label="Started On"
                name={'start_year_2'}
                dependencies={['end_year_2']}
                rules={[
                  {
                    required: true,
                    message: "Please enter Started On!"
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (showMasters && !value) {
                        return Promise.reject(new Error("Master's start date is required."));
                      }
                      if (showMasters && value && dayjs(value).isAfter(dayjs())) {
                        return Promise.reject(new Error("Date cannot be in the future."));
                      }
                      const bachelorsEndDate = getFieldValue("end_year_1");
                      const mastersEndDate = getFieldValue("end_year_2");

                      if (value && bachelorsEndDate && dayjs(value).isBefore(bachelorsEndDate)) {
                        return Promise.reject(new Error("Master's start date must be after Bachelor's end date!"));
                      }

                      if (value && mastersEndDate) {
                        if (dayjs(value).isBefore(mastersEndDate)) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject(new Error("Master's start date must be before Master's end date!"));
                        }
                      }

                      // If no mastersEndDate, just resolve if value is present
                      return Promise.resolve();
                    }
                  })
                ]}
              >
                <DatePicker
                  format="MM/DD/YYYY"
                  autoComplete="off"
                  className="ant-input"
                  style={{ width: '100%' }}
                  onChange={() => form.validateFields(['end_date'])}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label="Ended On"
                name={'end_year_2'}
                dependencies={['start_year_2']}
                rules={[
                  {
                    required: true,
                    message: "Please enter Ended On!"
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (showMasters && value && dayjs(value).isAfter(dayjs())) {
                        return Promise.reject(new Error("Date cannot be in the future."));
                      }
                      if (showMasters && !value) {
                        return Promise.reject();
                      }
                      if (!value || !getFieldValue("start_year_2") || dayjs(value).isAfter(getFieldValue("start_year_2"))) {
                        return Promise.resolve();
                      }
                        return Promise.reject(new Error('End date must be after start date!'));
                    },
                  }),
                  
                ]}
              >
                <DatePicker
                  format="MM/DD/YYYY"
                  autoComplete="off"
                  className="ant-input"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
                        </>
                    )}
                </>
            )}
            <Divider />
            <Col span={2}>
                          
            </Col>
          </Row>  
        </Form>
    </div>
  );
}

export default Page2;
